/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type NotificationSettingsResponseDto = {
  id: number;
  name: NotificationSettingsResponseDto.name;
  severity: NotificationSettingsResponseDto.severity;
  value: string;
  deliveryChannel: NotificationSettingsResponseDto.deliveryChannel;
  enabled: boolean;
};
export namespace NotificationSettingsResponseDto {
  export enum name {
    ALL = 'ALL',
    BATTERY_STATUS = 'BATTERY_STATUS',
    CO_STATUS = 'CO_STATUS',
    CO_SELFTEST = 'CO_SELFTEST',
    DEVICE_STATUS = 'DEVICE_STATUS',
    SMOKE_STATUS = 'SMOKE_STATUS',
    HUMID_STATUS = 'HUMID_STATUS',
    HUMID_PREDICTION_STATUS = 'HUMID_PREDICTION_STATUS',
    TEMP_STATUS = 'TEMP_STATUS',
    TEMP_PREDICTION_STATUS = 'TEMP_PREDICTION_STATUS',
    VOC_STATUS = 'VOC_STATUS',
    VOC_PREDICTION_STATUS = 'VOC_PREDICTION_STATUS',
    COVER_STATUS = 'COVER_STATUS',
    FW_DOWNLOAD = 'FW_DOWNLOAD',
    FW_UPDATE = 'FW_UPDATE',
    SIREN_STATUS = 'SIREN_STATUS',
    LOG_SENDING = 'LOG_SENDING',
    EXTERNAL_POWER = 'EXTERNAL_POWER',
    SIGNAL_STATUS = 'SIGNAL_STATUS',
    PRESSURE_STATUS = 'PRESSURE_STATUS',
    HEALTH_STATUS = 'HEALTH_STATUS',
    SMOKE_SENSOR_STATUS = 'SMOKE_SENSOR_STATUS',
    DEVICE_SELF_TEST = 'DEVICE_SELF_TEST',
    CO_SENSOR_SELF_TEST = 'CO_SENSOR_SELF_TEST',
    DOWNLINK_STATUS = 'DOWNLINK_STATUS',
    FIRMWARE_UPDATE_STATUS = 'FIRMWARE_UPDATE_STATUS',
    LOG_STATUS = 'LOG_STATUS',
    NETWORK_STATUS = 'NETWORK_STATUS',
    PAIRING_STATUS = 'PAIRING_STATUS',
    DEVICE_REMINDER = 'DEVICE_REMINDER',
    CO2_STATUS = 'CO2_STATUS',
  }
  export enum severity {
    INFO = 'INFO',
    WARNING = 'WARNING',
    CRITICAL = 'CRITICAL',
    ERROR = 'ERROR',
  }
  export enum deliveryChannel {
    PUSH = 'PUSH',
    SMS = 'SMS',
    CALL = 'CALL',
  }
}

